export const stringToHslColor = (str, s, l, a = 1) => {
  var hash = 0;
  for (var i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var h = hash % 360;
  return 'hsla(' + h + ', ' + s + '%, ' + l + '%, ' + a + ')';
};
